import { GetPaginatedAssetsForTransfersQuery } from '@bts-web/data-layer/server';
import {
  TAssetsForTransfersResponse,
  TPaginatedAssetsForDepositResponse,
} from './types';
import { TAssetForTransferArray } from '../../types';
import { CRYPTO_TRANSFERS_ASSET_ITEMS_PER_PAGE } from '../../../config';

export const getPaginatedAssetsForTransferInitialQueryParams = {
  first: CRYPTO_TRANSFERS_ASSET_ITEMS_PER_PAGE,
  type: 'CRYPTOCOIN',
} satisfies GetPaginatedAssetsForTransfersQuery['variables']['input'];

export const EmptyPaginatedAssetsForTransfersResponse = {
  assetGroups: [],
  assets: {
    edges: [],
    totalCount: 0,
    pageInfo: {
      hasNextPage: false,
      endCursor: null,
      hasPreviousPage: false,
      startCursor: null,
    },
  },
} satisfies TPaginatedAssetsForDepositResponse;

export const extractDepositAndSellAssets = (
  responseData: TAssetsForTransfersResponse,
) => {
  const assetsListForDeposit: TAssetForTransferArray = [];

  const assetsListForSend: TAssetForTransferArray = [];

  if ('assets' in responseData && responseData.assets) {
    responseData.assets.edges?.forEach((item) => {
      if (item?.node) {
        assetsListForDeposit.push(item.node);
      }
    });
  }

  if ('portfolio' in responseData && responseData.portfolio?.assets) {
    responseData.portfolio.assets.edges?.forEach((item) => {
      if (item?.node && item.node?.__typename === 'CryptoAsset') {
        assetsListForSend.push({
          ...item.node,
          portfolio: {
            assetBalance: item.assetBalance,
            fiatBalance: item.fiatBalance,
          },
        } as TAssetForTransferArray[number]);
      }
    });
  }

  return { assetsListForDeposit, assetsListForSend };
};
